import axios from 'axios'

export default {
  state: {
    contacts: null
  },
  getters: {
    contacts: state => state.contacts
  },
  mutations: {
    setContacts(state, contacts) {
      state.contacts = contacts
    }
  },
  actions: {
    getContacts({ commit, rootGetters }, user) {
      return axios
        .get(`/users?hospital=${user.hospital}`, {
          headers: {
            Authorization: `Bearer ${rootGetters.accessToken}`
          }
        })
        .then(response => {
          const users = response.data

          const contacts = users.filter(u => u.id !== user.id)
          commit('setContacts', contacts)
          return contacts
        })
    },

    getContact({ rootGetters }, userId) {
      if (userId) {
        return axios
          .get(`/users/${userId}`, {
            headers: {
              Authorization: `Bearer ${rootGetters.accessToken}`
            }
          })
          .then(response => {
            return response.data
          })
      } else {
        return Promise.reject(Error('No userId provided'))
      }
    },
    addContact({ rootGetters }, userId) {
      const url = `https://us-central1-xerpa-40c1c.cloudfunctions.net/webapi/v1/users/${rootGetters.user.id}/contacts`
      // const url = `http://localhost:5000/xerpa-40c1c/us-central1/webapi/v1/users/${rootGetters.user.id}/contacts`;
      const body = {
        userId
      }
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(res => {
        if (res.ok) {
          return res.json()
        } else {
          throw Error('Could not add contact')
        }
      })
    },

    // TODO: add contact request accept page
    sendContactRequest({ dispatch, rootGetters }, userId) {
      return dispatch('getContact', userId)
        .then(contact => {
          if (contact) {
            const { user } = rootGetters
            const contacts = [...(user.contacts || [])]
            if (!contacts.find(c => c.id === contact.id)) {
              contacts.push({
                id: contact.id,
                username: contact.username,
                picture: contact.picture
              })
              const payload = { contacts }
              return dispatch('updateUser', payload, { root: true })
            } else {
              throw Error('User already in contact list')
            }
          } else {
            throw Error('User not found')
          }
        })
        .then(() => {
          return dispatch('getUser', rootGetters.user.id, { root: true })
        })
    }
  }
}
